var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconContainer, { IconSVG } from "./IconContainer";
var IconFileReference = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(11.775 9.141) rotate(45)" },
                    React.createElement("path", { d: "M3.4-1.6v5.1h5.1" }),
                    React.createElement("path", { d: "M20.2,6.8c0.9-4.1-1.6-8.2-5.7-9.1c-2.6-0.6-5.2,0.2-7.1,2L3.4,3.5" })),
                React.createElement("g", { transform: "translate(1.083 5.416)" },
                    React.createElement("path", { d: "M15.8,18H6.3c-1.2,0-2.2-1-2.2-2.2v-4.4" })),
                React.createElement("g", { transform: "translate(18.417 1.083) rotate(90)" },
                    React.createElement("path", { d: "M18,13.2H2.8c-1.2,0-2.2-1-2.2-2.2V2.6l5.4-5h2.3" }))))));
});
export default IconFileReference;
//# sourceMappingURL=IconFileReference.js.map